import { API_ENDPOINTS } from "constants/api";
import { customApiCall, getApiHost, IOptions } from "utils/api";
import {
  SendOTPRequest,
  SendOTPResponse,
  SignInRequest,
  SignInResponse,
  RefreshRequest,
  RefreshResponse,
  SignOutRequest
} from "../types/auth";

export const sendOTP = (request: SendOTPRequest): Promise<SendOTPResponse> => {
  const opts: IOptions = {
    method: "POST",
    body: JSON.stringify(request),
    headers: {
      "x-client-id": "influencer-app",
    },
  };
  return customApiCall(getApiHost(), API_ENDPOINTS.SEND_OTP, opts);
};

export const signIn = (request: SignInRequest): Promise<SignInResponse> => {
  const opts: IOptions = {
    method: "POST",
    body: JSON.stringify(request),
    headers: {
      "x-client-id": "influencer-app",
    },
  };
  return customApiCall(getApiHost(), API_ENDPOINTS.SIGN_IN, opts);
};

export const refreshToken = (request: RefreshRequest): Promise<RefreshResponse> => {
  const opts: IOptions = {
    method: "POST",
    body: JSON.stringify(request),
    headers: {
      "x-client-id": "influencer-app",
    },
  };
  return customApiCall(getApiHost(), API_ENDPOINTS.REFRESH_TOKEN, opts);
};

export const signOut = (request: SignOutRequest): Promise<any> => {
  const opts: IOptions = {
    method: "POST",
    body: JSON.stringify(request),
    headers: {
      "x-client-id": "influencer-app",
    },
  };
  return customApiCall(getApiHost(), API_ENDPOINTS.SIGN_OUT, opts);
};

// Helper function to create device context
export const createDeviceContext = () => ({
  platform: 3, // PLATFORM_WEB
  user_agent: typeof window !== "undefined" ? window.navigator.userAgent : "Chrome/5.0",
});

